<div class="page-container">
  <div class="card p-3 m-3 position-relative">
    <!-- Bottone toggle in alto a destra -->
    <button type="button"
            class="position-absolute"
            style="top: 10px; right: 10px; border: none; background: none; padding: 0; margin: 0; line-height: 1;"
            (click)="showFilters = !showFilters"
            [title]="showFilters ? 'Nascondi filtri' : 'Mostra filtri'">
      <i class="bi" [ngClass]="showFilters ? 'bi-chevron-up' : 'bi-chevron-down'" style="font-size: 1.4rem; padding: 5px;"></i>
    </button>

    <div class="row px-3 mb-2">
      <div class="mb-2 d-flex align-items-end gap-3">
        <h2 class="mb-0"><b>Elenco Totale Resi (con tutti gli stati)</b></h2>
        <span>Totale: {{ filteredMergedPallets.length }}</span>
      </div>
<!-- 
      <div class="d-flex justify-content-between flex-wrap w-100 align-items-end"> -->

      <div *ngIf="showFilters">
        <div class="d-flex flex-wrap gap-3 mb-3">
            <div class="mb-0 " style="min-width: 200px;" *ngIf="filteredClients.length > 1">
              <div class="multi-select-wrapper">
                    <ng-multiselect-dropdown
                            *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
                            name="clients"
                            [placeholder]="'Seleziona clienti'"
                            [settings]="dropdownSettingsClient"
                            [data]="filteredClients"
                            [(ngModel)]="selectedClients"
                            [ngModelOptions]="{standalone: true}"
                            (onSelect)="onClientsChange()"
                            (onDeSelect)="onClientsChange()"
                            (onSelectAll)="selectAllClients()"
                            (onDeSelectAll)="deselectAllClients()"
                    >
                    </ng-multiselect-dropdown>

                </div>
            </div>
            <div class="mb-0 " style="min-width: 200px;" *ngIf="filteredBrands.length > 1">
                <div class="multi-select-wrapper">
                    <ng-multiselect-dropdown *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
                                              name="brands"
                                              [placeholder]="'Seleziona marchi'"
                                              [settings]="dropdownSettingsBrand"
                                              [data]="filteredBrands"
                                              [(ngModel)]="selectedBrands"
                                              [ngModelOptions]="{standalone: true}"
                    >
                    </ng-multiselect-dropdown>
                </div>
            </div>
            <!-- Select gruppo -->
            <div class="position-relative" style="width: 200px;">
              <label for="palletTypesGroupCode" class="custom-label">Gruppi tipologie</label>
              <select  id="palletTypesGroupCode" class="form-select" [(ngModel)]="palletTypesGroupCode" name="palletTypesGroupCode" (change)="onGroupChange()">
                <option value="">Tutte</option>
                <option *ngFor="let group of uniquePalletTypesGroup" [value]="group.palletTypesGroupCode">
                  {{ group.palletTypesGroupName }}
                </option>
              </select>
            </div>

            <!-- Select nome tipologia -->
             <div class="position-relative" style="width: 200px;">
              <label for="palletTypesGroupCode" class="custom-label">Tipologie Specifiche</label>
              <select 
                class="form-select"
                [(ngModel)]="palletTypesCode"
                name="palletTypesCode"
                [disabled]="!palletTypesGroupCode">
                
                <option value="">Tutte</option>
                <option *ngFor="let type of filteredNamesByGroup" [value]="type.palletTypesCode">
                  {{ type.palletTypesCode }} - {{ type.palletTypeName }}
                </option>
              </select>
             </div>
          <div class="mb-2">
            <input type="text" class="form-control" placeholder="Codice Dealer" [(ngModel)]="searchDealerCode" />
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="selectedDealerCode">
              <option value="">Tutti i dealer</option>
              <option *ngFor="let dealer of filteredDealers" [value]="dealer.dealerCode">
                {{ dealer.dealerName }} - {{ dealer.dealerOperatingAddressCity }} ({{ dealer.count }})
              </option>
            </select>
          </div>
          <div class="mb-2">
            <input type="text" class="form-control" placeholder="Codice Reso" [(ngModel)]="searchPalletCode" />
          </div>
          <div class="mb-2">
            <input type="text" class="form-control" placeholder="Codice Bolla" [(ngModel)]="searchWaybillCode" />
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="palletCurrentStatus">
              <option value="">Tutti gli stati</option>
              <option value="0">Pianificati (stato 0)</option>
              <option value="1">Affidati (stato 1)</option>
              <option value="2">Ritirati dall’autista (stato 2)</option>
              <option value="3">Entrati in magazzino (stato 3)</option>
              <option value="4">Usciti dal magazzino (stato 4)</option>
              <option value="5">Consegnati (stato 5)</option>
              <option value="6">Chiusi forzatamente (stato 6)</option>
            </select>
          </div>
          <div class="mb-2">
              <select class="form-select" [(ngModel)]="errorStatus">
                <option value="ALL">In errore e non</option>
                <option value="">Solo stati corretti</option>
                <option value="ERROR">Solo stati errati</option>
              </select>
          </div>
          <div class="mb-2">
              <select class="form-select" [(ngModel)]="onTimeStatus">
                <option value="">In orario e non</option>
                <option value="NOT_ON_TIME">Solo in ritardo</option>
                <option value="ON_TIME">Solo in orario</option>
              </select>
          </div>   
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="selectedCarrierCode" name="carrierCode">
              <option value="">Tutti i vettori</option>
              <option *ngFor="let carrier of filteredCarriers" [value]="carrier.carrierCode">
                {{ carrier.carrierName }}  ({{ carrier.count }})
              </option>
            </select>
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="warehouseCode" name="warehouseCode">
              <option value="">Tutti i magazzini</option>
              <option *ngFor="let warehouse of filteredWarehouses" [value]="warehouse.warehouseCode">
                {{ warehouse.warehouseName }}
              </option>
            </select>
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="selectedRegionCode" name="regionCode">
              <option value="">Tutte le regioni</option>
              <option *ngFor="let region of filteredRegions" [value]="region.regionCode">
                {{ region.regionName }}  ({{ region.count }})
              </option>
            </select>
          </div>

          <!-- FILTRO DATE CREAZIONE -->
          <div class="mb-2 d-flex">
            <button class="btn btn-light shift-btn back" (click)="shiftAffidoDates(-1)" title="Indietro di 1 giorno">
                  <i class="fa-solid fa-caret-left"></i>
            </button>
            <div class="d-flex align-items-end flex-wrap  align-content-center">
              <!-- Data inizio -->
              <div class="position-relative" style="width: 200px;">
                <label for="dateStart" class="custom-label">Data inizio affido</label>
                <input type="date" id="dateStart" [(ngModel)]="dateStart" class="form-control no-padding-input" />
                
              </div>
              <!-- Data fine -->
              <div class="position-relative" style="width: 200px;">
                <label for="dateEnd" class="custom-label">Data fine affido</label>
                <input type="date" id="dateEnd" [(ngModel)]="dateEnd" class="form-control no-padding-input" />
                
              </div>
            </div>
            <button class="btn btn-light shift-btn forward" (click)="shiftAffidoDates(1)" title="Avanti di 1 giorno">
                  <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>

          <!-- FILTRO DATE CREAZIONE -->
          <div class="mb-2 d-flex">
            <button class="btn btn-light shift-btn back" (click)="shiftCreationDates(-1)" title="Indietro di 1 giorno">
                  <i class="fa-solid fa-caret-left"></i>
            </button>
            <div class="d-flex align-items-end flex-wrap  align-content-center">
              <!-- Data inizio -->
              <div class="position-relative" style="width: 200px;">
                <label for="dateCreationStart" class="custom-label">Data inizio creazione</label>
                <input type="date" id="dateCreationStart" [(ngModel)]="dateCreationStart" class="form-control no-padding-input" />
                
              </div>
              <!-- Data fine -->
              <div class="position-relative" style="width: 200px;">
                <label for="dateCreationEnd" class="custom-label">Data fine creazione</label>
                <input type="date" id="dateCreationEnd" [(ngModel)]="dateCreationEnd" class="form-control no-padding-input" />
                
              </div>
            </div>
            <button class="btn btn-light shift-btn forward" (click)="shiftCreationDates(1)" title="Avanti di 1 giorno">
                  <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button class="btn btn-primary" (click)="applyFilters()">Applica Filtri</button>
          <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
        </div>
      </div>
        
    </div>
  </div>





    <div class="row px-3 mb-3">
      <div class="col-12 d-flex justify-content-end align-items-center gap-2 flex-wrap flex-md-nowrap">

        <!-- Bottone Excel Dettaglio -->
        <button class="btn btn-green"
                type="button"
                (click)="exportParcelsDetailsToExcel()"
                title="Esporta Excel Dettaglio">
          <i class="fas fa-file-excel"></i>
        </button>

        <!-- Select righe per pagina -->
        <select class="form-select"
                [(ngModel)]="itemsPerPage"
                (change)="onItemsPerPageChange()"
                style="width: auto;"
                title="Numero righe">
          <option [ngValue]="10">10</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>

        <!-- Bottone reset -->
        <button class="btn btn-primary"
                type="button"
                (click)="resetItemsPerPage()"
                title="Reset numero righe">
          <i class="fa fa-undo"></i>
        </button>
        
      </div>
    </div>


  <!-- Errore filtri -->
  <div *ngIf="dateError" class="alert alert-danger mx-3">
    {{ dateError }}
  </div>

  <!-- Tabella Colli -->
  <div *ngIf="!isLoading && mergedPallets.length > 0">
  <div class="table-wrapper mx-3">
    <table class="table fixed-header-table table-hover">
      <thead class="bg-light">
        <tr>
          <th>Codice Reso</th>
          <th>Tipologia</th>
          <th>Codice Bolla</th>
          <th scope="col" (click)="setSort('palletDate')" style="cursor: pointer;">
              Data Affido
              <i class="bi" [ngClass]="{
                'bi-arrow-down': sortState.active === 'palletDate' && sortState.direction === 'desc',
                'bi-arrow-up': sortState.active === 'palletDate' && sortState.direction === 'asc',
                'bi-arrow-down-up': sortState.active !== 'palletDate' || sortState.direction === ''
              }"></i>
          </th>
          <th scope="col" (click)="setSort('palletDeliveryType')" style="cursor: pointer;">
              Contenuto
              <i class="bi" [ngClass]="{
                'bi-arrow-down': sortState.active === 'palletDeliveryType' && sortState.direction === 'desc',
                'bi-arrow-up': sortState.active === 'palletDeliveryType' && sortState.direction === 'asc',
                'bi-arrow-down-up': sortState.active !== 'palletDeliveryType' || sortState.direction === ''
              }"></i>
          </th>
          <th>Codice Dealer</th>
          <th scope="col" (click)="setSort('dealerName')" style="cursor: pointer;">
              Dealer
              <i class="bi" [ngClass]="{
                'bi-arrow-down': sortState.active === 'dealerName' && sortState.direction === 'desc',
                'bi-arrow-up': sortState.active === 'dealerName' && sortState.direction === 'asc',
                'bi-arrow-down-up': sortState.active !== 'dealerName' || sortState.direction === ''
              }"></i>
          </th>
          <th>Indirizzo Dealer</th>
          <th>Stato</th>
          <th scope="col" (click)="setSort('palletComplementaryValueDate')" style="cursor: pointer;">
              Data Stato
              <i class="bi" [ngClass]="{
                'bi-arrow-down': sortState.active === 'palletComplementaryValueDate' && sortState.direction === 'desc',
                'bi-arrow-up': sortState.active === 'palletComplementaryValueDate' && sortState.direction === 'asc',
                'bi-arrow-down-up': sortState.active !== 'palletComplementaryValueDate' || sortState.direction === ''
              }"></i>
          </th>
          <th>Magazzino</th>
          <th>Vettore</th>
          <!-- <th>Inviato</th> -->
          <th scope="col" (click)="setSort('palletActualDeliveryDate')" style="cursor: pointer;">
              Data consegna
              <i class="bi" [ngClass]="{
                'bi-arrow-down': sortState.active === 'palletActualDeliveryDate' && sortState.direction === 'desc',
                'bi-arrow-up': sortState.active === 'palletActualDeliveryDate' && sortState.direction === 'asc',
                'bi-arrow-down-up': sortState.active !== 'palletActualDeliveryDate' || sortState.direction === ''
              }"></i>
          </th>
          <th>Data stimata</th>
          <th>In orario</th>
          <th scope="col" (click)="setSort('regionName')" style="cursor: pointer;">
              Regione
              <i class="bi" [ngClass]="{
                'bi-arrow-down': sortState.active === 'regionName' && sortState.direction === 'desc',
                'bi-arrow-up': sortState.active === 'regionName' && sortState.direction === 'asc',
                'bi-arrow-down-up': sortState.active !== 'regionName' || sortState.direction === ''
              }"></i>
          </th>
          <th>Codice spedizione</th>
          <th scope="col" (click)="setSort('palletCurrentStatus')" style="cursor: pointer;">
              Stato Corrente
              <i class="bi" [ngClass]="{
                'bi-arrow-down': sortState.active === 'palletCurrentStatus' && sortState.direction === 'desc',
                'bi-arrow-up': sortState.active === 'palletCurrentStatus' && sortState.direction === 'asc',
                'bi-arrow-down-up': sortState.active !== 'palletCurrentStatus' || sortState.direction === ''
              }"></i>
          </th>
        </tr>
      </thead>
    <tbody>
    <ng-container *ngFor="let p of filteredMergedPallets | paginate: { id: 'pallet-pagination', itemsPerPage: itemsPerPage, currentPage: currentPage }">
      <tr [ngClass]="{ 'error-row': p.comPallet.palletComplementaryValueStatus === 'ERROR' }" 
      [attr.title]="p.comPallet.palletComplementaryValueStatus === 'ERROR' ? 'Stato non considerato: data creazione stato errata' : null">
        <!-- Dati oprPallet -->
        <td>{{ p.oprPallet.palletCode }}</td>
        <td>{{ p.oprPallet.palletTypesGroupName }}</td>
        <td>{{ p.oprPallet.palletWaybillCode }}</td>
        <td>{{ p.oprPallet.palletDate | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ p.oprPallet.palletDeliveryType }}</td>
        <td>{{ p.oprPallet.palletDealerCode }}</td>
        <td>{{ p.oprPallet.dealerName }}</td>
        <td>{{ p.oprPallet.dealerOperatingAddressStreet }} - {{ p.oprPallet.dealerOperatingAddressCity }}</td>
        

        <!-- Dati comPallet -->
        <td>{{ p.comPallet.palletComplementaryValueNumber }}</td>
        <td>{{ p.comPallet.palletComplementaryValueDate | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ p.comPallet.warehouseCodeName }}</td>
        <td>{{ p.comPallet.carrierName }}</td>
        <!-- <td>
          <ng-container *ngIf="p.comPallet.palletComplementaryStatus === 'SENT'; else showStatus">
            <i class="fas fa-check text-success"></i>
          </ng-container>
          <ng-template #showStatus>
            {{
              p.comPallet.palletComplementaryStatus === 'INSERTED' || p.comPallet.palletComplementaryStatus === 'CLOSED'
                ? ''
                : p.comPallet.palletComplementaryStatus
            }}
          </ng-template>
        </td> -->

        <td>{{ p.oprPallet.palletStatus === 'DELIVERED' ? (p.oprPallet.palletActualDeliveryDate | date: 'dd/MM/yyyy HH:mm') : '' }}</td>
        <td>{{ p.oprPallet.palletEstimatedDeliveryDate | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
            <ng-container [ngSwitch]="p.oprPallet.palletOnTime">
              <span class="is-valid" *ngSwitchCase="'ON_TIME'">Si</span>
              <span class="is-invalid" *ngSwitchCase="'NOT_ON_TIME'">No</span>
              <span *ngSwitchDefault>{{ p.oprPallet.palletOnTime }}</span>
            </ng-container>
        </td>
        <td>{{ p.oprPallet.regionName }}</td>
        <td>{{ p.oprPallet.palletShipmentCode }}</td>
        <td>{{ p.oprPallet.palletCurrentStatus }}</td>
      </tr>
    </ng-container>
  </tbody>

    </table>
  </div>
</div>

  <div *ngIf="!isLoading && mergedPallets.length === 0" class="mx-3">
    <div class="alert alert-warning d-flex align-items-center justify-content-between">
      <div>
        <i class="fas fa-exclamation-triangle me-2"></i>
        <span>Nessun reso trovato con i filtri selezionati.</span>
      </div>
      <!--tolto perché non applicava i filtri sopra -->
      <!-- <button class="action-btn primary" (click)="loadData()">
      <i class="fa fa-refresh me-1"></i>
      <span class="action-text">Riprova</span>
    </button> -->
    </div>
  </div>


  <!-- Pagination -->
  <pagination-controls id="pallet-pagination" [maxSize]="5" [autoHide]="true" [responsive]="true" previousLabel="←"
    nextLabel="→" class="d-flex justify-content-end mt-3" (pageChange)="onPageChange($event)">
  </pagination-controls>

</div>

<!-- Loader centrato -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
    <span class="visually-hidden">Caricamento...</span>
  </div>
</div>